import { Language, type SupportedLanguage } from './types';

export enum LocalizationNamespace {
	AgentConfiguration = 'agentConfiguration',
	AssigneeModal = 'assigneeModal',
	Attributes = 'attributes',
	Auth = 'auth',
	AuthConnect = 'authConnect',
	Billing = 'billing',
	Branding = 'branding',
	Common = 'common',
	Contacts = 'contacts',
	Contractors = 'contractors',
	Contracts = 'contracts',
	Creator = 'creator',
	CrmDashboard = 'crmDashboard',
	Dashboard = 'dashboard',
	Employees = 'employees',
	Home = 'home',
	Onboarding = 'onboarding',
	PartnerCustomers = 'partnerCustomers',
	Profile = 'profile',
	SessionDetails = 'sessionDetails',
	Sessions = 'sessions',
	Settings = 'settings',
	Sidebar = 'sidebar',
	Team = 'team',
	TestEmployee = 'testEmployee',
	VibeCreator = 'vibeCreator',
	Widgets = 'widgets'
}

export const SUPPORTED_LANGUAGES: SupportedLanguage[] = [
	Language.En,
	Language.Es,
	Language.It
];

export const DEFAULT_LANGUAGE: SupportedLanguage = Language.En;

export const LanguageMeta = {
	en: {
		label: 'English',
		flag: '🇺🇸'
	},
	es: {
		label: 'Español',
		flag: '🇪🇸'
	},
	it: {
		label: 'Italiano',
		flag: '🇮🇹'
	}
} as const;
